<template>
  <div class="app-container">
    <!-- 搜索区域 -->
    <div class="filter-container">
      
      
     
      <el-button
        class="filter-item"
        type="default"
        icon="el-icon-refresh"
        @click="resetQuery"
      >
        刷新
      </el-button>
    </div>

    <!-- 表格区域 -->
    <el-table
      :key="tableKey"
      v-loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%;"
    >
      <el-table-column label="序号" type="index" align="center" width="60" />
      <el-table-column label="用户昵称" prop="nick" align="center" />
      <el-table-column label="头像" align="center" width="80">
        <template slot-scope="{row}">
          <img v-if="row.avatar" :src="row.avatar" alt="头像" style="width: 50px; height: 50px; border-radius: 50%;">
          <span v-else>无头像</span>
        </template>
      </el-table-column>
      <el-table-column label="提现人姓名" prop="username" align="center" width="100" />
      <el-table-column label="手机号" prop="mobile" align="center" />
      <el-table-column label="提现金额" prop="reflected_amount" align="center">
        <template slot-scope="{row}">
          <span class="amount">¥{{ row.reflected_amount }}</span>
        </template>
      </el-table-column>
      <el-table-column label="提现状态" align="center" width="120">
        <template slot-scope="{row}">
          <el-tag :type="getStatusTag(row.verify_status)">
            {{ getStatusLabel(row.verify_status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="提现时间" align="center" width="160">
        <template slot-scope="{row}">
          <span>{{ row.reflected_time | parseTime('{y}-{m}-{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.page"
      :limit.sync="queryParams.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>
import { parseTime } from '@/utils'
import Pagination from '@/components/Pagination'
import { postAction } from '@/api/user'

export default {
  name: 'WithdrawalList',
  components: { Pagination },
  filters: { parseTime },
  data() {
    return {
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      queryParams: {
        page: 1,
        limit: 10,
        nickName: '',
        phoneNum: '',
        verifyStatus: ''
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.listLoading = true
      try {
        // 构建请求参数
        const params = {
          page: this.queryParams.page,
          limit: this.queryParams.limit
        }

        // 添加搜索条件
        if (this.queryParams.nickName) {
          params.nickName = this.queryParams.nickName
        }
        if (this.queryParams.phoneNum) {
          params.phoneNum = this.queryParams.phoneNum
        }
        if (this.queryParams.verifyStatus) {
          params.verifyStatus = this.queryParams.verifyStatus
        }

        console.log('个人提现记录请求参数:', params)
        const res = await postAction('/api/center/withdrawList', params)
        console.log('个人提现记录响应结果:', res)

        if (res.code === 200) {
          this.list = res.data.data || []
          this.total = res.data.total || 0
          console.log('个人提现记录数据加载成功:', this.list.length, '条记录')
        } else {
          this.$message.error(res.msg || '获取数据失败')
          this.list = []
          this.total = 0
        }
      } catch (error) {
        console.error('获取个人提现记录失败:', error)
        this.$message.error('获取数据失败，请稍后重试')
        this.list = []
        this.total = 0
      } finally {
        this.listLoading = false
      }
    },
    
    handleQuery() {
      this.queryParams.page = 1
      this.getList()
    },
    
    resetQuery() {
      this.queryParams = {
        page: 1,
        limit: 10,
        nickName: '',
        phoneNum: '',
        verifyStatus: ''
      }
      this.getList()
    },
    
    getStatusLabel(verifyStatus) {
      const statusMap = {
        0: '待审核',
        1: '提现至银行卡',
        2: '提现至支付宝',
        3: '提现至微信',
        4: '已驳回',
        5: '已打款',
        6: '提现失败'
      }
      return statusMap[verifyStatus] || '未知'
    },

    getStatusTag(verifyStatus) {
      const tagMap = {
        0: 'warning',
        1: 'success',
        2: 'success',
        3: 'success',
        4: 'danger',
        5: 'success',
        6: 'danger'
      }
      return tagMap[verifyStatus] || 'info'
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-container {
  padding-bottom: 10px;
  
  .filter-item {
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 10px;
    margin-right: 10px;
  }
}

.amount {
  color: #e6a23c;
  font-weight: bold;
}
</style>